import React, { Fragment } from "react";
import { Col, Input, InputGroup, Label, Row } from "reactstrap";
import { Github, Href, SocialLinks, Submit, Twitter } from "../../../../../../constants";
import { StudentFormProp } from "../../../../../../types/Forms";

const SocialLinksForm: React.FC<StudentFormProp> = ({ formData, updateFormData, register, errors }) => {
  return (
    <Fragment>
      <h5 className="mb-2">{SocialLinks}</h5>
      <Row className="g-3">
        <Col sm="6">
          <Label>{Twitter}</Label>
          <Input value={formData.twitterUrl} {...register("twitterUrl", { required: "Twitter URL  is required" })} onChange={updateFormData} type="url" placeholder="https://twitter.com" />
          {errors.twitterUrl && <span className="text-danger">{errors.twitterUrl.message}</span>}
        </Col>
        <Col sm="6">
          <Label>{Github}</Label>
          <Input value={formData.gitHubUrl} {...register("gitHubUrl", { required: "Github URL is required" })} onChange={updateFormData} type="url" placeholder="https:/github.com" />
          {errors.gitHubUrl && <span className="text-danger">{errors.gitHubUrl.message}</span>}
        </Col>
        <Col xs="12">
          <InputGroup>
            <Input {...register("studentFile", { required: "File is required" })} onChange={updateFormData} type="file"/>
            <a className="btn btn-outline-secondary" href={Href}>{Submit}</a>
          </InputGroup>
            {errors.studentFile && <span className="text-danger">{errors.studentFile.message}</span>}
        </Col>
        <Col xs="12">
          <Input value={formData.positions} {...register("positions", { required: "Position is required" })} onChange={updateFormData} type="select">
            <option value={""}>{"Positions"}</option>
            <option value={"1"}>{"Web Designer"}</option>
            <option value={"2"}>{"Software Engineer"}</option>
            <option value={"3"}>{"UI/UX Designer "}</option>
            <option value={"4"}>{"Web Developer"}</option>
          </Input>
          {errors.positions && <span className="text-danger">{errors.positions.message}</span>}
        </Col>
        <Col xs="12">
          <Label>{"Why do you want to take this position?"}</Label>
          <Input {...register("positionQuestion", { required: "Position Question is required" })} onChange={updateFormData} id="questionsTextarea" type="textarea" rows={2}/>
          {errors.positionQuestion && <span className="text-danger">{errors.positionQuestion.message}</span>}
        </Col>
      </Row>
    </Fragment>
  );
};
export default SocialLinksForm;
